import React from "react"
const { site } = require("../../../../utils/site")

const Main = ({ children }) => {
  return (
  <main className={site}>
    {children}
  </main>
  )
}

export default Main
